import React from 'react';
import { HugeiconsIcon } from '@hugeicons/react';
import { GitMergeIcon } from '@hugeicons/core-free-icons';

export type IconProps = {
  color: string;
  width?: number;
  height?: number;
  size?: number;
};

export const BackIcon = ({
  color = '#242424',
  width = 11,
  height = 16,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 11 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.546 14.1067L4.43935 8L10.546 1.88L8.66602 0L0.666016 8L8.66602 16L10.546 14.1067Z"
      fill={color}
    />
  </svg>
);

export const MergeIcon = () => (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.75001 4.49999C9.1967 4.50101 8.66305 4.70531 8.25053 5.07405C7.838 5.44279 7.57535 5.95026 7.51251 6.49999H6.15626C5.78975 6.5014 5.4275 6.4214 5.09567 6.26576C4.76385 6.11011 4.47074 5.88272 4.23751 5.59999L3.15626 4.30624C3.64346 4.08996 4.03776 3.70729 4.26851 3.22677C4.49927 2.74624 4.5514 2.19926 4.41559 1.6838C4.27978 1.16833 3.96488 0.718062 3.52731 0.41363C3.08973 0.109199 2.55807 -0.0295016 2.02754 0.0223721C1.49701 0.0742458 1.00229 0.313305 0.63197 0.69673C0.261653 1.08016 0.0399412 1.5829 0.00654618 2.11491C-0.0268488 2.64692 0.130255 3.17344 0.449717 3.60016C0.76918 4.02688 1.23013 4.32593 1.75001 4.44374V7.55624C1.21066 7.67917 0.735503 7.99647 0.415293 8.44755C0.0950821 8.89862 -0.0477375 9.45185 0.0141143 10.0016C0.0759661 10.5513 0.338154 11.0589 0.750597 11.4276C1.16304 11.7962 1.69683 12 2.25001 12C2.80318 12 3.33697 11.7962 3.74941 11.4276C4.16186 11.0589 4.42404 10.5513 4.4859 10.0016C4.54775 9.45185 4.40493 8.89862 4.08472 8.44755C3.76451 7.99647 3.28935 7.67917 2.75001 7.55624V5.38124L3.46876 6.23749C3.79505 6.63406 4.20548 6.95308 4.67031 7.17144C5.13513 7.3898 5.6427 7.50203 6.15626 7.49999H7.63126C7.76879 7.889 8.01065 8.2327 8.33037 8.4935C8.6501 8.75431 9.03539 8.92217 9.4441 8.97874C9.85281 9.03531 10.2692 8.97841 10.6477 8.81425C11.0263 8.65009 11.3524 8.385 11.5904 8.04798C11.8285 7.71095 11.9692 7.31496 11.9973 6.90331C12.0255 6.49166 11.9398 6.08021 11.7499 5.71395C11.5599 5.34769 11.2728 5.04072 10.9201 4.82662C10.5674 4.61251 10.1626 4.49952 9.75001 4.49999ZM3.50001 9.74999C3.50001 9.99722 3.42669 10.2389 3.28934 10.4445C3.15199 10.65 2.95677 10.8102 2.72836 10.9048C2.49995 10.9994 2.24862 11.0242 2.00614 10.976C1.76367 10.9277 1.54094 10.8087 1.36612 10.6339C1.19131 10.4591 1.07226 10.2363 1.02402 9.99385C0.975792 9.75138 1.00055 9.50004 1.09516 9.27164C1.18977 9.04323 1.34998 8.84801 1.55554 8.71065C1.7611 8.5733 2.00278 8.49999 2.25001 8.49999C2.58102 8.50163 2.89801 8.63386 3.13207 8.86792C3.36614 9.10199 3.49836 9.41898 3.50001 9.74999ZM9.75001 7.99999C9.50278 7.99999 9.2611 7.92668 9.05554 7.78933C8.84998 7.65198 8.68977 7.45675 8.59516 7.22834C8.50055 6.99994 8.47579 6.7486 8.52402 6.50613C8.57226 6.26365 8.69131 6.04092 8.86612 5.86611C9.04094 5.69129 9.26367 5.57224 9.50614 5.52401C9.74862 5.47578 9.99995 5.50053 10.2284 5.59514C10.4568 5.68975 10.652 5.84997 10.7893 6.05553C10.9267 6.26109 11 6.50276 11 6.74999C10.9984 7.081 10.8661 7.39799 10.6321 7.63206C10.398 7.86612 10.081 7.99835 9.75001 7.99999Z"
      fill="#5579F2"
    />
  </svg>
);

export const MergeCustomIcon = ({
  color,
  size = 16,
}: {
  color: string;
  size?: number;
}) => (
  <HugeiconsIcon
    icon={GitMergeIcon}
    size={size}
    color={color}
    strokeWidth={1.5}
  />
);

export const BackVideoIcon = ({
  color = '#242424',
  width = 40,
  height = 40,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="20" fill={color} />
    <path
      d="M23.9902 14.645L18.6352 20L23.9902 25.355L22.3336 27L15.3336 20L22.3336 13L23.9902 14.645Z"
      fill="white"
    />
  </svg>
);

export const SortIcon = ({
  color = '#242424',
  width = 16,
  height = 18,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 86 285"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M57 199.5H0L85.5 285V0H57V199.5Z" fill={color} />
  </svg>
);

export const PlusIcon = ({
  color = '#242424',
  width = 20,
  height = 20,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.3337 11.3327H11.3337V19.3327H8.66699V11.3327H0.666992V8.66602H8.66699V0.666016H11.3337V8.66602H19.3337V11.3327Z"
      fill={color}
    />
  </svg>
);

export const SearchIcon = ({
  color = '#242424',
  width = 20,
  height = 20,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.00319 12.0064C9.76638 12.0064 12.0064 9.76638 12.0064 7.00319C12.0064 4.24001 9.76638 2 7.00319 2C4.24001 2 2 4.24001 2 7.00319C2 9.76638 4.24001 12.0064 7.00319 12.0064Z"
      stroke={color}
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9997 14.0007L10.5381 10.5391"
      stroke={color}
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TrashIcon = ({
  color = '#F95572',
  width = 24,
  height = 24,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00033 25.3333C8.00033 26.0406 8.28128 26.7189 8.78137 27.219C9.28147 27.719 9.95975 28 10.667 28H21.3337C22.0409 28 22.7192 27.719 23.2193 27.219C23.7194 26.7189 24.0003 26.0406 24.0003 25.3333V9.33333H8.00033V25.3333ZM10.667 12H21.3337V25.3333H10.667V12ZM20.667 5.33333L19.3337 4H12.667L11.3337 5.33333H6.66699V8H25.3337V5.33333H20.667Z"
      fill={color}
    />
  </svg>
);

export const DuplicateIcon = ({
  color = '#F95572',
  width = 24,
  height = 24,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 16H5C4.73478 16 4.48043 15.8946 4.29289 15.7071C4.10536 15.5196 4 15.2652 4 15V5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H15C15.2652 4 15.5196 4.10536 15.7071 4.29289C15.8946 4.48043 16 4.73478 16 5V6M9 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V9C20 8.73478 19.8946 8.48043 19.7071 8.29289C19.5196 8.10536 19.2652 8 19 8H9C8.73478 8 8.48043 8.10536 8.29289 8.29289C8.10536 8.48043 8 8.73478 8 9V19C8 19.2652 8.10536 19.5196 8.29289 19.7071C8.48043 19.8946 8.73478 20 9 20Z"
      stroke={color}
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export const EditQuesIcon = ({
  color = '#F95572',
  width = 24,
  height = 24,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.46266 12.8883L3 13.8574L3.96954 10.3961L10.3101 4.08885C10.3817 4.01559 10.4673 3.95738 10.5618 3.91764C10.6563 3.87789 10.7577 3.85742 10.8602 3.85742C10.9627 3.85742 11.0642 3.87789 11.1587 3.91764C11.2532 3.95738 11.3387 4.01559 11.4104 4.08885L12.7724 5.45799C12.8445 5.52949 12.9018 5.61456 12.9408 5.7083C12.9799 5.80203 13 5.90256 13 6.0041C13 6.10565 12.9799 6.20618 12.9408 6.29991C12.9018 6.39364 12.8445 6.47872 12.7724 6.55022L6.46266 12.8883Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EditQuesThinIcon = ({
  color = '#F95572',
  width = 24,
  height = 24,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.46266 12.8883L3 13.8574L3.96954 10.3961L10.3101 4.08885C10.3817 4.01559 10.4673 3.95738 10.5618 3.91764C10.6563 3.87789 10.7577 3.85742 10.8602 3.85742C10.9627 3.85742 11.0642 3.87789 11.1587 3.91764C11.2532 3.95738 11.3387 4.01559 11.4104 4.08885L12.7724 5.45799C12.8445 5.52949 12.9018 5.61456 12.9408 5.7083C12.9799 5.80203 13 5.90256 13 6.0041C13 6.10565 12.9799 6.20618 12.9408 6.29991C12.9018 6.39364 12.8445 6.47872 12.7724 6.55022L6.46266 12.8883Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.75px"
    />
  </svg>
);

export const MediaQuesIcon = ({
  color = '#F95572',
  width = 24,
  height = 24,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0762 2.00195H2.92212C2.41231 2.00195 1.99902 2.41524 1.99902 2.92505V13.0791C1.99902 13.5889 2.41231 14.0022 2.92212 14.0022H13.0762C13.586 14.0022 13.9993 13.5889 13.9993 13.0791V2.92505C13.9993 2.41524 13.586 2.00195 13.0762 2.00195Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.60547 11.2915V7.75601C6.60805 7.70167 6.62393 7.64881 6.65171 7.60204C6.67949 7.55528 6.71832 7.51605 6.7648 7.4878C6.81128 7.45955 6.86398 7.44313 6.91829 7.44C6.97259 7.43687 7.02683 7.44712 7.07625 7.46985L10.1409 9.23296C10.1906 9.26354 10.2315 9.30632 10.26 9.35722C10.2884 9.40812 10.3033 9.46544 10.3033 9.52374C10.3033 9.58204 10.2884 9.63936 10.26 9.69026C10.2315 9.74116 10.1906 9.78393 10.1409 9.81451L7.07625 11.5869C7.02598 11.6075 6.9715 11.6159 6.91734 11.6113C6.86318 11.6066 6.81091 11.5892 6.76487 11.5603C6.71883 11.5314 6.68035 11.4919 6.65262 11.4452C6.6249 11.3984 6.60873 11.3457 6.60547 11.2915V11.2915Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.99902 5.23438H13.9993"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.22949 5.2328L6.61414 2.00195"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.38477 5.2328L10.7694 2.00195"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LogicQuesIcon = ({
  color = '#F95572',
  width = 24,
  height = 24,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9366 4.9502C13.9187 4.85349 13.8807 4.76162 13.8251 4.68054C13.7694 4.59947 13.6973 4.531 13.6135 4.47958L11.7673 6.32513C11.6811 6.41444 11.5779 6.48548 11.4637 6.534C11.3495 6.58252 11.2267 6.60752 11.1026 6.60752C10.9785 6.60752 10.8557 6.58252 10.7415 6.534C10.6273 6.48548 10.5241 6.41444 10.438 6.32513L9.73643 5.69764C9.56729 5.52515 9.47255 5.29324 9.47255 5.0517C9.47255 4.81016 9.56729 4.57825 9.73643 4.40576L11.5826 2.56021C11.5424 2.46566 11.4818 2.38111 11.4052 2.31254C11.3287 2.24397 11.238 2.19306 11.1395 2.16342C10.4954 2.035 9.82809 2.08997 9.21364 2.32206C8.59919 2.55415 8.06227 2.95404 7.66402 3.4762C7.26577 3.99836 7.02218 4.62181 6.96099 5.27557C6.89979 5.92933 7.02345 6.58713 7.31789 7.17408L2.27774 12.1663C2.18982 12.2522 2.11996 12.3549 2.07226 12.4682C2.02457 12.5815 2 12.7032 2 12.8261C2 12.949 2.02457 13.0707 2.07226 13.184C2.11996 13.2973 2.18982 13.3999 2.27774 13.4859L2.61006 13.8181C2.69603 13.906 2.7987 13.9758 2.91204 14.0235C3.02538 14.0711 3.14711 14.0957 3.27008 14.0957C3.39305 14.0957 3.51477 14.0711 3.62812 14.0235C3.74146 13.9758 3.84413 13.906 3.9301 13.8181L8.97025 8.78894C9.55757 9.06866 10.211 9.18005 10.8579 9.11073C11.5047 9.04141 12.1197 8.79409 12.6343 8.39628C13.149 7.99847 13.5432 7.46576 13.7731 6.85738C14.003 6.249 14.0596 5.5888 13.9366 4.9502V4.9502Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LangQuesIcon = ({
  color = '#F95572',
  width = 24,
  height = 24,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00014 14.0003C11.3139 14.0003 14.0003 11.3139 14.0003 8.00014C14.0003 4.68635 11.3139 2 8.00014 2C4.68635 2 2 4.68635 2 8.00014C2 11.3139 4.68635 14.0003 8.00014 14.0003Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 8H14.0003"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3079 8.00014C10.1945 10.1943 9.38633 12.2956 8.00013 14.0003C6.61393 12.2956 5.80574 10.1943 5.69238 8.00014C5.80574 5.80594 6.61393 3.70464 8.00013 2C9.38633 3.70464 10.1945 5.80594 10.3079 8.00014V8.00014Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CopyQuesIcon = ({
  color = '#F95572',
  width = 24,
  height = 24,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.15332 3.8462L7.99952 2L9.84571 3.8462"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.15332 12.1543L7.99952 14.0005L9.84571 12.1543"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 2V14.0003"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.1543 6.1543L14.0005 8.00049L12.1543 9.84669"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.8462 6.1543L2 8.00049L3.8462 9.84669"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0003 8H2"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CrossIcon = ({
  color = '#F95572',
  width = 12,
  height = 12,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    className="tags-font"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_905_4112)">
      <path
        d="M15.4284 0.571411L0.571289 15.4286"
        stroke={color || '#F95572'}
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.571289 0.571411L15.4284 15.4286"
        stroke={color || '#F95572'}
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_905_4112">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AudioLoading = ({ animate = true }) => {
  const twClass = animate ? 'animate-audio-pulse' : '';
  return (
    <div className="flex items-center justify-center h-full w-[60%]">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 38.05">
        <title>Audio Wave</title>
        <path
          className={twClass}
          style={{ animationDelay: '0.15s' }}
          d="M0.91,15L0.78,15A1,1,0,0,0,0,16v6a1,1,0,1,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H0.91Z"
        />
        <path
          className={twClass}
          style={{ animationDelay: '0.30s' }}
          d="M6.91,9L6.78,9A1,1,0,0,0,6,10V28a1,1,0,1,0,2,0s0,0,0,0V10A1,1,0,0,0,7,9H6.91Z"
        />
        <path
          className={twClass}
          style={{ animationDelay: '0.45s' }}
          d="M12.91,0L12.78,0A1,1,0,0,0,12,1V37a1,1,0,1,0,2,0s0,0,0,0V1a1,1,0,0,0-1-1H12.91Z"
        />
        <path
          className={twClass}
          style={{ animationDelay: '0.60s' }}
          d="M18.91,10l-0.12,0A1,1,0,0,0,18,11V27a1,1,0,1,0,2,0s0,0,0,0V11a1,1,0,0,0-1-1H18.91Z"
        />
        <path
          className={twClass}
          style={{ animationDelay: '0.75s' }}
          d="M24.91,15l-0.12,0A1,1,0,0,0,24,16v6a1,1,0,0,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H24.91Z"
        />
        <path
          className={twClass}
          style={{ animationDelay: '0.90s' }}
          d="M30.91,10l-0.12,0A1,1,0,0,0,30,11V27a1,1,0,1,0,2,0s0,0,0,0V11a1,1,0,0,0-1-1H30.91Z"
        />
        <path
          className={twClass}
          style={{ animationDelay: '1.05s' }}
          d="M36.91,0L36.78,0A1,1,0,0,0,36,1V37a1,1,0,1,0,2,0s0,0,0,0V1a1,1,0,0,0-1-1H36.91Z"
        />
        <path
          className={twClass}
          style={{ animationDelay: '1.20s' }}
          d="M42.91,9L42.78,9A1,1,0,0,0,42,10V28a1,1,0,1,0,2,0s0,0,0,0V10a1,1,0,0,0-1-1H42.91Z"
        />
        <path
          className={twClass}
          style={{ animationDelay: '1.35s' }}
          d="M48.91,15l-0.12,0A1,1,0,0,0,48,16v6a1,1,0,1,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H48.91Z"
        />
      </svg>
    </div>
  );
};

export const LoadingIcon: React.FC<any> = ({
  width,
  height,
  color,
  strokeWidth = 10,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ margin: 'auto', display: 'block', shapeRendering: 'auto' }}
    width={width}
    height={height}
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
  >
    <circle
      cx="50"
      cy="50"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      r="32"
      strokeDasharray="150.79644737231007 52.26548245743669"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        repeatCount="indefinite"
        dur="0.9900990099009901s"
        values="0 50 50;360 50 50"
        keyTimes="0;1"
      ></animateTransform>
    </circle>
  </svg>
);

export const DesktopComputerIcon = ({
  color = '#242424',
  width = 12,
  height = 12,
}: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.286 3.42773H1.71456C1.24118 3.42773 0.857422 3.81149 0.857422 4.28488V17.9992C0.857422 18.4726 1.24118 18.8563 1.71456 18.8563H22.286C22.7594 18.8563 23.1431 18.4726 23.1431 17.9992V4.28488C23.1431 3.81149 22.7594 3.42773 22.286 3.42773Z"
      stroke={color}
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.2856 18.8555L8.57129 23.1412"
      stroke={color}
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.7148 18.8555L15.4291 23.1412"
      stroke={color}
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.85742 23.1426H17.1431"
      stroke={color}
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DeviceMobileIcon = ({
  color = '#242424',
  width = 12,
  height = 12,
}: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.8573 0.857422H5.143C4.19622 0.857422 3.42871 1.62493 3.42871 2.57171V21.4289C3.42871 22.3756 4.19622 23.1431 5.143 23.1431H18.8573C19.8041 23.1431 20.5716 22.3756 20.5716 21.4289V2.57171C20.5716 1.62493 19.8041 0.857422 18.8573 0.857422Z"
      stroke={color}
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.7148 18.8574H13.2863"
      stroke={color}
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlayIcon = ({
  color = '#242424',
  width = 24,
  height = 24,
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill={color}
    width={width}
    height={height}
  >
    <path
      fillRule="evenodd"
      d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z"
      clipRule="evenodd"
    />
  </svg>
);

export const RecordVideoIcon = ({ color = '#FFFFFF' }: IconProps) => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.82308 8.625C8.23454 8.625 6.71107 9.25604 5.5878 10.3793C4.46454 11.5026 3.8335 13.026 3.8335 14.6146V31.3854C3.8335 32.974 4.46454 34.4974 5.5878 35.6207C6.71107 36.744 8.23454 37.375 9.82308 37.375H26.5939C28.1824 37.375 29.7059 36.744 30.8292 35.6207C31.9525 34.4974 32.5835 32.974 32.5835 31.3854V29.049L38.2961 33.511C39.8697 34.7396 42.1668 33.6183 42.1668 31.6231V14.3769C42.1668 12.3817 39.8697 11.2604 38.2961 12.489L32.5835 16.951V14.6146C32.5835 13.026 31.9525 11.5026 30.8292 10.3793C29.7059 9.25604 28.1824 8.625 26.5939 8.625H9.82308ZM32.5835 19.9908L39.771 14.3769V31.6221L32.5835 26.0092V19.9908ZM30.1877 14.6146V31.3854C30.1877 31.8574 30.0947 32.3247 29.9141 32.7607C29.7335 33.1967 29.4688 33.5929 29.1351 33.9266C28.8014 34.2603 28.4052 34.525 27.9692 34.7056C27.5332 34.8862 27.0659 34.9792 26.5939 34.9792H9.82308C8.86996 34.9792 7.95587 34.6005 7.28191 33.9266C6.60796 33.2526 6.22933 32.3385 6.22933 31.3854V14.6146C6.22933 13.6615 6.60796 12.7474 7.28191 12.0734C7.95587 11.3995 8.86996 11.0208 9.82308 11.0208H26.5939C27.0659 11.0208 27.5332 11.1138 27.9692 11.2944C28.4052 11.475 28.8014 11.7397 29.1351 12.0734C29.4688 12.4071 29.7335 12.8033 29.9141 13.2393C30.0947 13.6753 30.1877 14.1426 30.1877 14.6146Z"
      fill={color}
    />
  </svg>
);

export const MicIcon = ({ color = '#FFFFFF' }: IconProps) => (
  <svg
    width="63"
    height="63"
    viewBox="0 0 63 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="31.3203" cy="31.3203" r="30.8203" fill="white" stroke={color} />
    <g clipPath="url(#clip0_1209_396)">
      <path
        d="M23.9023 28.8477C24.1209 28.8477 24.3306 28.9345 24.4852 29.0891C24.6397 29.2436 24.7266 29.4533 24.7266 29.6719V31.3203C24.7266 33.0691 25.4213 34.7462 26.6578 35.9828C27.8944 37.2194 29.5715 37.9141 31.3203 37.9141C33.0691 37.9141 34.7462 37.2194 35.9828 35.9828C37.2194 34.7462 37.9141 33.0691 37.9141 31.3203V29.6719C37.9141 29.4533 38.0009 29.2436 38.1555 29.0891C38.31 28.9345 38.5197 28.8477 38.7383 28.8477C38.9569 28.8477 39.1665 28.9345 39.3211 29.0891C39.4757 29.2436 39.5625 29.4533 39.5625 29.6719V31.3203C39.5625 33.3636 38.8036 35.3341 37.4329 36.8494C36.0622 38.3648 34.1776 39.317 32.1445 39.5213V42.8594H37.0898C37.3084 42.8594 37.5181 42.9462 37.6727 43.1008C37.8272 43.2554 37.9141 43.465 37.9141 43.6836C37.9141 43.9022 37.8272 44.1118 37.6727 44.2664C37.5181 44.421 37.3084 44.5078 37.0898 44.5078H25.5508C25.3322 44.5078 25.1225 44.421 24.968 44.2664C24.8134 44.1118 24.7266 43.9022 24.7266 43.6836C24.7266 43.465 24.8134 43.2554 24.968 43.1008C25.1225 42.9462 25.3322 42.8594 25.5508 42.8594H30.4961V39.5213C28.4631 39.317 26.5784 38.3648 25.2077 36.8494C23.837 35.3341 23.0781 33.3636 23.0781 31.3203V29.6719C23.0781 29.4533 23.165 29.2436 23.3195 29.0891C23.4741 28.9345 23.6837 28.8477 23.9023 28.8477Z"
        fill={color}
      />
      <path
        d="M34.6172 31.3203C34.6172 32.1947 34.2698 33.0333 33.6516 33.6516C33.0333 34.2698 32.1947 34.6172 31.3203 34.6172C30.4459 34.6172 29.6074 34.2698 28.9891 33.6516C28.3708 33.0333 28.0234 32.1947 28.0234 31.3203V23.0781C28.0234 22.2037 28.3708 21.3652 28.9891 20.7469C29.6074 20.1286 30.4459 19.7812 31.3203 19.7812C32.1947 19.7812 33.0333 20.1286 33.6516 20.7469C34.2698 21.3652 34.6172 22.2037 34.6172 23.0781V31.3203ZM31.3203 18.1328C30.0087 18.1328 28.7509 18.6538 27.8234 19.5813C26.896 20.5087 26.375 21.7665 26.375 23.0781V31.3203C26.375 32.6319 26.896 33.8898 27.8234 34.8172C28.7509 35.7446 30.0087 36.2656 31.3203 36.2656C32.6319 36.2656 33.8898 35.7446 34.8172 34.8172C35.7446 33.8898 36.2656 32.6319 36.2656 31.3203V23.0781C36.2656 21.7665 35.7446 20.5087 34.8172 19.5813C33.8898 18.6538 32.6319 18.1328 31.3203 18.1328V18.1328Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_1209_396">
        <rect
          width="26.375"
          height="26.375"
          fill="white"
          transform="translate(18.1328 18.1328)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const BillingIcon = ({ color = '#242424', width, height }) => (
  <svg
    width={width || '16'}
    height={height || '16'}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2529_1825)">
      <path
        d="M8.00038 4.87496L8 3"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 9.8C6 10.7 6.89333 11 8 11C9.10667 11 10 11 10 9.8C10 8 6 8 6 6.2C6 5 6.89333 5 8 5C9.10667 5 10 5.456 10 6.2"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00391 11.125L8.00429 13"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2529_1825">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LogOutIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    strokeWidth={1.5}
    stroke="currentColor"
    width="18"
    height="18"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
    />
  </svg>
);

export const LargeProjectIcon = ({
  color = '#FFFFFF',
  size = 48,
}: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.68127 24.8634L5.00595 13.3335C4.99191 13.2174 5.00278 13.0996 5.03783 12.9879C5.07288 12.8763 5.13131 12.7735 5.20924 12.6862C5.28716 12.5989 5.38278 12.5292 5.48973 12.4818C5.59669 12.4344 5.71252 12.4103 5.82952 12.4112H13.4227C13.6073 12.4123 13.7864 12.4742 13.9323 12.5874C14.0782 12.7005 14.1827 12.8585 14.2298 13.0371L14.8886 15.7054H25.595C25.7088 15.705 25.8215 15.7283 25.926 15.7737C26.0305 15.8192 26.1245 15.8858 26.2019 15.9694C26.2793 16.053 26.3385 16.1517 26.3757 16.2594C26.413 16.367 26.4276 16.4813 26.4185 16.5948L25.7761 24.8304C25.7428 25.244 25.5548 25.6299 25.2495 25.9107C24.9441 26.1918 24.5439 26.3471 24.129 26.3457H7.32839C6.91864 26.3479 6.52283 26.1971 6.21827 25.923C5.9137 25.6489 5.72225 25.271 5.68127 24.8634Z"
      stroke="#242424"
    />
    <path
      d="M9.94824 9.11779V5.82355C9.94824 5.60514 10.035 5.39566 10.1895 5.24121C10.3439 5.08677 10.5534 5 10.7718 5H24.7723C24.9908 5 25.2002 5.08677 25.3547 5.24121C25.509 5.39566 25.5958 5.60514 25.5958 5.82355V12.412"
      stroke="#242424"
    />
    <path d="M16.5352 9.11816H21.4765" stroke="#242424" />
  </svg>
);

export const ProjectIcon = ({ color = '#FFFFFF', height }: IconProps) => (
  <svg
    width={height ? '48' : '32'}
    height={height ? '48' : '32'}
    viewBox={height ? `0 0 32 32` : '0 0 32 32'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.4083 23.7587L7.86804 14.5348C7.85681 14.4419 7.8655 14.3476 7.89354 14.2583C7.92159 14.169 7.96833 14.0867 8.03067 14.0169C8.09301 13.9471 8.1695 13.8914 8.25507 13.8534C8.34063 13.8155 8.4333 13.7962 8.5269 13.7969H14.6015C14.7491 13.7978 14.8924 13.8473 15.0091 13.9379C15.1258 14.0284 15.2095 14.1548 15.2471 14.2976L15.7742 16.4323H24.3393C24.4303 16.432 24.5205 16.4506 24.6041 16.487C24.6877 16.5233 24.7629 16.5766 24.8248 16.6435C24.8867 16.7104 24.9341 16.7894 24.9638 16.8755C24.9937 16.9616 25.0053 17.053 24.9981 17.1438L24.4842 23.7323C24.4576 24.0632 24.3071 24.3718 24.0629 24.5966C23.8186 24.8214 23.4984 24.9457 23.1664 24.9445H9.726C9.39819 24.9463 9.08155 24.8257 8.8379 24.6064C8.59424 24.3871 8.44108 24.0848 8.4083 23.7587Z"
      stroke={color}
    />
    <path
      d="M11.8223 11.1614V8.52603C11.8223 8.3513 11.8917 8.18372 12.0152 8.06016C12.1388 7.9366 12.3064 7.86719 12.4811 7.86719H23.6815C23.8563 7.86719 24.0238 7.9366 24.1474 8.06016C24.2709 8.18372 24.3403 8.3513 24.3403 8.52603V13.7968"
      stroke={color}
    />
    <path d="M17.0918 11.1621H21.0449" stroke={color} />
  </svg>
);

export const NonSelectedProjectIcon = ({
  color = '#FFFFFF',
  width = 32,
  height = 32,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.9091 14.5454C25.9091 13.9668 25.6792 13.4118 25.27 13.0027C24.8609 12.5935 24.3059 12.3636 23.7272 12.3636H16.4545L14.36 8H9.18182C8.60317 8 8.04821 8.22986 7.63904 8.63904C7.22987 9.04821 7 9.60316 7 10.1818V21.8182C7 22.3968 7.22987 22.9518 7.63904 23.3609C8.04821 23.7701 8.60317 24 9.18182 24H23.7272C24.3059 24 24.8609 23.7701 25.27 23.3609C25.6792 22.9518 25.9091 22.3968 25.9091 21.8182V14.5454Z"
      stroke="#242424"
      stroke-width="0.666667"
    />
  </svg>
);

export const LargeAddProjectIcon = ({
  color = '#4a4a4a',
  size = 48,
}: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25.5984 5.6H14.7271L13.3662 4.24L12.8059 4H4.80053L4 4.8V22.4L4.80053 23.2H13.5904V21.6H5.56904V12H12.7578L13.3182 11.76L14.6951 10.384H24.7979V12.784L24.7963 13.6H26.4149V6.4L25.5984 5.6ZM24.7819 8.8H14.3749L13.8145 9.04L12.4376 10.416H5.58505V5.616H12.4536L13.8145 6.976L14.3909 7.216H24.7979L24.7819 8.8ZM23.1968 28H21.5957V23.2H16.7925V21.6H21.5957V16.8H23.1968V21.6H28V23.2H23.1968V28Z"
      fill={color}
    />
  </svg>
);

export const NeedHelpQuestionIcon = ({
  color = '#FFFFFF',
  width = 18,
  height = 18,
}: IconProps) => (
  <svg
    width={height}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_83_298)">
      <path
        d="M17.8572 0.714294H2.14293C1.76405 0.714294 1.40068 0.864804 1.13277 1.13271C0.864865 1.40062 0.714355 1.76399 0.714355 2.14287V14.2857C0.714355 14.6646 0.864865 15.028 1.13277 15.2959C1.40068 15.5638 1.76405 15.7143 2.14293 15.7143H5.00007V19.2857L9.45721 15.7143H17.8572C18.2361 15.7143 18.5995 15.5638 18.8674 15.2959C19.1353 15.028 19.2858 14.6646 19.2858 14.2857V2.14287C19.2858 1.76399 19.1353 1.40062 18.8674 1.13271C18.5995 0.864804 18.2361 0.714294 17.8572 0.714294Z"
        stroke="#242424"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.85718 6.42859C7.85718 6.00478 7.98285 5.59048 8.21831 5.23809C8.45377 4.8857 8.78844 4.61104 9.18 4.44885C9.57155 4.28666 10.0024 4.24423 10.4181 4.32691C10.8338 4.40959 11.2156 4.61368 11.5153 4.91337C11.8149 5.21305 12.019 5.59487 12.1017 6.01054C12.1844 6.42622 12.142 6.85707 11.9798 7.24863C11.8176 7.64019 11.5429 7.97485 11.1905 8.21031C10.8382 8.44577 10.4239 8.57145 10 8.57145V9.28574"
        stroke="#242424"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0001 11.4286C9.78823 11.4286 9.58108 11.4914 9.40489 11.6092C9.22869 11.7269 9.09136 11.8942 9.01027 12.09C8.92918 12.2858 8.90796 12.5012 8.9493 12.709C8.99064 12.9169 9.09268 13.1078 9.24253 13.2576C9.39237 13.4075 9.58328 13.5095 9.79111 13.5509C9.99895 13.5922 10.2144 13.571 10.4102 13.4899C10.6059 13.4088 10.7733 13.2715 10.891 13.0953C11.0087 12.9191 11.0716 12.7119 11.0716 12.5C11.0679 12.217 10.9538 11.9466 10.7537 11.7465C10.5535 11.5464 10.2832 11.4323 10.0001 11.4286V11.4286Z"
        fill="#242424"
      />
    </g>
    <defs>
      <clipPath id="clip0_83_298">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DownArrowIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.81667 0.157031L5 3.9737L1.175 0.157031L-2.18557e-07 1.33203L5 6.33203L10 1.33203L8.81667 0.157031Z"
        fill="#242424"
      />
    </svg>
  );
};

export const EnterIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2502 4.5C14.0513 4.5 13.8605 4.57902 13.7198 4.71967C13.5792 4.86032 13.5002 5.05109 13.5002 5.25V8.25C13.5002 8.44891 13.4212 8.63968 13.2805 8.78033C13.1398 8.92098 12.9491 9 12.7502 9H5.55767L6.53267 8.0325C6.67389 7.89127 6.75324 7.69973 6.75324 7.5C6.75324 7.30027 6.67389 7.10873 6.53267 6.9675C6.39144 6.82627 6.19989 6.74693 6.00017 6.74693C5.80044 6.74693 5.60889 6.82627 5.46767 6.9675L3.21767 9.2175C3.14939 9.28883 3.09586 9.37294 3.06017 9.465C2.98515 9.6476 2.98515 9.8524 3.06017 10.035C3.09586 10.1271 3.14939 10.2112 3.21767 10.2825L5.46767 12.5325C5.53739 12.6028 5.62034 12.6586 5.71173 12.6967C5.80313 12.7347 5.90116 12.7543 6.00017 12.7543C6.09918 12.7543 6.19721 12.7347 6.2886 12.6967C6.37999 12.6586 6.46294 12.6028 6.53267 12.5325C6.60296 12.4628 6.65876 12.3798 6.69684 12.2884C6.73491 12.197 6.75452 12.099 6.75452 12C6.75452 11.901 6.73491 11.803 6.69684 11.7116C6.65876 11.6202 6.60296 11.5372 6.53267 11.4675L5.55767 10.5H12.7502C13.3469 10.5 13.9192 10.2629 14.3412 9.84099C14.7631 9.41903 15.0002 8.84674 15.0002 8.25V5.25C15.0002 5.05109 14.9212 4.86032 14.7805 4.71967C14.6398 4.57902 14.4491 4.5 14.2502 4.5Z"
        fill="white"
      />
    </svg>
  );
};

export const TranslateLanguage = ({
  small,
  color = '#242424',
  smaller,
}: any) => (
  <svg
    width={smaller ? '20' : small ? '24' : '48'}
    height={smaller ? '20' : small ? '24' : '48'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9186_3832)">
      <path
        d="M17 20H2.5C1.8372 19.9992 1.20178 19.7356 0.73311 19.2669C0.264441 18.7982 0.000793929 18.1628 0 17.5L0 2.5C0 1.122 1.122 0 2.5 0H10.5C10.6042 5.94992e-06 10.7059 0.0325885 10.7907 0.0931914C10.8755 0.153794 10.9392 0.239387 10.973 0.338L17.473 19.338C17.4983 19.4133 17.5054 19.4935 17.4937 19.572C17.482 19.6506 17.4518 19.7252 17.4056 19.7898C17.3595 19.8545 17.2986 19.9072 17.2281 19.9437C17.1576 19.9803 17.0794 19.9996 17 20ZM2.5 1C1.673 1 1 1.673 1 2.5V17.5C1 18.327 1.673 19 2.5 19H16.3L10.143 1H2.5Z"
        fill={color}
      />
      <path
        d="M21.5 24H13.5C13.3983 24 13.299 23.969 13.2154 23.9111C13.1318 23.8532 13.0678 23.7712 13.032 23.676L11.532 19.676C11.4853 19.5519 11.4899 19.4143 11.5446 19.2935C11.5994 19.1728 11.6999 19.0787 11.824 19.032C11.9481 18.9853 12.0857 18.9899 12.2065 19.0446C12.3272 19.0994 12.4213 19.1999 12.468 19.324L13.847 23H21.5C22.327 23 23 22.327 23 21.5V6.5C23 5.673 22.327 5 21.5 5H12C11.8674 5 11.7402 4.94732 11.6464 4.85355C11.5527 4.75979 11.5 4.63261 11.5 4.5C11.5 4.36739 11.5527 4.24021 11.6464 4.14645C11.7402 4.05268 11.8674 4 12 4H21.5C22.878 4 24 5.122 24 6.5V21.5C24 22.878 22.878 24 21.5 24Z"
        fill={color}
      />
      <path
        d="M13.5 23.9999C13.4038 24 13.3097 23.9724 13.2288 23.9203C13.148 23.8682 13.0839 23.7939 13.0442 23.7063C13.0045 23.6187 12.9909 23.5215 13.0051 23.4263C13.0192 23.3312 13.0605 23.2422 13.124 23.1699L16.624 19.1699C16.6673 19.1205 16.7199 19.0801 16.7788 19.0509C16.8377 19.0218 16.9017 19.0046 16.9673 19.0002C17.0328 18.9959 17.0986 19.0045 17.1608 19.0255C17.2231 19.0466 17.2806 19.0797 17.33 19.1229C17.3794 19.1662 17.4199 19.2188 17.449 19.2777C17.4781 19.3366 17.4954 19.4007 17.4997 19.4662C17.5041 19.5318 17.4955 19.5975 17.4744 19.6598C17.4534 19.722 17.4203 19.7795 17.377 19.8289L13.877 23.8289C13.8299 23.8826 13.772 23.9256 13.707 23.9551C13.6419 23.9846 13.5714 23.9999 13.5 23.9999ZM9.5 13.9999C9.3968 14.0001 9.29609 13.9683 9.21174 13.9088C9.12738 13.8493 9.06354 13.7652 9.029 13.6679L7 7.98695L4.971 13.6679C4.92645 13.7929 4.83409 13.895 4.71426 13.9518C4.59442 14.0086 4.45692 14.0155 4.332 13.9709C4.20709 13.9264 4.10499 13.834 4.04816 13.7142C3.99134 13.5944 3.98445 13.4569 4.029 13.3319L6.529 6.33195C6.671 5.93395 7.329 5.93395 7.47 6.33195L9.97 13.3319C9.9969 13.4073 10.0053 13.4881 9.99451 13.5674C9.98372 13.6467 9.95405 13.7222 9.908 13.7877C9.86195 13.8531 9.80085 13.9066 9.72986 13.9435C9.65886 13.9804 9.58004 13.9998 9.5 13.9999Z"
        fill={color}
      />
      <path
        d="M8 11H6C5.86739 11 5.74021 10.9473 5.64645 10.8536C5.55268 10.7598 5.5 10.6326 5.5 10.5C5.5 10.3674 5.55268 10.2402 5.64645 10.1464C5.74021 10.0527 5.86739 10 6 10H8C8.13261 10 8.25979 10.0527 8.35355 10.1464C8.44732 10.2402 8.5 10.3674 8.5 10.5C8.5 10.6326 8.44732 10.7598 8.35355 10.8536C8.25979 10.9473 8.13261 11 8 11ZM21.5 11H14.5C14.3674 11 14.2402 10.9473 14.1464 10.8536C14.0527 10.7598 14 10.6326 14 10.5C14 10.3674 14.0527 10.2402 14.1464 10.1464C14.2402 10.0527 14.3674 10 14.5 10H21.5C21.6326 10 21.7598 10.0527 21.8536 10.1464C21.9473 10.2402 22 10.3674 22 10.5C22 10.6326 21.9473 10.7598 21.8536 10.8536C21.7598 10.9473 21.6326 11 21.5 11Z"
        fill={color}
      />
      <path
        d="M17.5 11C17.3674 11 17.2402 10.9473 17.1465 10.8536C17.0527 10.7598 17 10.6326 17 10.5V9.5C17 9.36739 17.0527 9.24021 17.1465 9.14645C17.2402 9.05268 17.3674 9 17.5 9C17.6326 9 17.7598 9.05268 17.8536 9.14645C17.9473 9.24021 18 9.36739 18 9.5V10.5C18 10.6326 17.9473 10.7598 17.8536 10.8536C17.7598 10.9473 17.6326 11 17.5 11ZM16 17C15.8935 17.0013 15.7893 16.9683 15.7028 16.906C15.6164 16.8436 15.5522 16.7552 15.5197 16.6537C15.4873 16.5522 15.4883 16.4429 15.5225 16.342C15.5568 16.2411 15.6225 16.1538 15.71 16.093C17.899 14.538 19.5 11.366 19.5 10.501C19.5 10.3684 19.5527 10.2412 19.6465 10.1474C19.7402 10.0537 19.8674 10.001 20 10.001C20.1326 10.001 20.2598 10.0537 20.3536 10.1474C20.4473 10.2412 20.5 10.3684 20.5 10.501C20.5 11.819 18.573 15.286 16.29 16.909C16.2049 16.9683 16.1037 17 16 17Z"
        fill={color}
      />
      <path
        d="M20 17.9999C19.8751 18.0004 19.7547 17.9536 19.663 17.8689C19.3 17.5369 16.105 14.5859 15.537 13.1879C15.4923 13.0662 15.4966 12.9319 15.5491 12.8133C15.6016 12.6947 15.6981 12.6011 15.8182 12.5524C15.9384 12.5036 16.0728 12.5034 16.1931 12.5518C16.3134 12.6002 16.4101 12.6935 16.463 12.8119C16.872 13.8189 19.399 16.2709 20.338 17.1309C20.4124 17.199 20.4645 17.2879 20.4875 17.3861C20.5104 17.4843 20.5031 17.5872 20.4666 17.6812C20.43 17.7752 20.3659 17.8559 20.2826 17.9128C20.1993 17.9697 20.1008 18 20 17.9999Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_9186_3832">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const TranscriptLanguage = ({ small = false }: any) => (
  <svg
    width={small ? '24' : '48'}
    height={small ? '24' : '48'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.6116 0H5.77562C5.59418 0 5.44743 0.146433 5.44743 0.327485V8.35602C4.67948 8.42058 3.97059 8.71205 3.42487 9.19251C2.71786 9.81474 2.34373 10.6966 2.34373 11.7427V15.5233C2.34373 16.5694 2.71739 17.4512 3.42487 18.0735C4.04795 18.6218 4.88248 18.9235 5.77562 18.9235C6.66875 18.9235 7.50375 18.6218 8.12637 18.0735C8.83337 17.4512 9.20751 16.5694 9.20751 15.5233V11.7427C9.20751 10.6966 8.83384 9.81474 8.12637 9.19251C7.58064 8.71205 6.87176 8.42105 6.1038 8.35602V3.07088H22.2463C22.259 3.07088 22.2712 3.06994 22.2834 3.06854V20.3808H8.0462C8.54035 20.1675 8.99465 19.883 9.3927 19.5331C10.4762 18.5792 11.0491 17.2248 11.0491 15.6154C11.0491 15.4344 10.9024 15.288 10.7209 15.288C10.5395 15.288 10.3927 15.4344 10.3927 15.6154C10.3927 18.7546 7.99931 20.1843 5.77562 20.1843C3.55192 20.1843 1.15851 18.7546 1.15851 15.6154C1.15851 15.4344 1.01176 15.288 0.830322 15.288C0.648882 15.288 0.502136 15.4344 0.502136 15.6154C0.502136 17.2248 1.07506 18.5796 2.15854 19.5331C3.03901 20.3078 4.19657 20.7621 5.44743 20.8299V22.6905C5.44743 22.7064 5.44884 22.7219 5.45118 22.7368H3.89277C3.71133 22.7368 3.56458 22.8833 3.56458 23.0643C3.56458 23.2454 3.71133 23.3918 3.89277 23.3918H7.65847C7.83991 23.3918 7.98665 23.2454 7.98665 23.0643C7.98665 22.8833 7.83991 22.7368 7.65847 22.7368H6.10005C6.1024 22.7219 6.1038 22.7064 6.1038 22.6905V21.0363H22.6116C22.793 21.0363 22.9397 20.8898 22.9397 20.7088V0.327485C22.9397 0.146433 22.793 0 22.6116 0ZM8.55113 11.7427V11.8185H6.29696C6.11552 11.8185 5.96878 11.9649 5.96878 12.146C5.96878 12.327 6.11552 12.4735 6.29696 12.4735H8.55113V13.3057H6.29696C6.11552 13.3057 5.96878 13.4522 5.96878 13.6332C5.96878 13.8143 6.11552 13.9607 6.29696 13.9607H8.55113V14.793H6.29696C6.11552 14.793 5.96878 14.9394 5.96878 15.1205C5.96878 15.3015 6.11552 15.448 6.29696 15.448H8.55113V15.5237C8.55113 17.4101 7.11227 18.269 5.77562 18.269C4.43896 18.269 3.0001 17.4101 3.0001 15.5237V11.7427C3.0001 9.85637 4.43896 8.99743 5.77562 8.99743C7.11227 8.99743 8.55113 9.85637 8.55113 11.7427ZM22.2463 2.41591H6.1038V0.654971H22.2834V2.41825C22.2712 2.41684 22.259 2.41591 22.2463 2.41591ZM15.9653 7.85029C15.9653 7.66924 16.1121 7.52281 16.2935 7.52281H19.8993C20.0808 7.52281 20.2275 7.66924 20.2275 7.85029C20.2275 8.03135 20.0808 8.17778 19.8993 8.17778H16.2935C16.1125 8.17778 15.9653 8.03135 15.9653 7.85029ZM15.9653 12.8342C15.9653 12.6531 16.1121 12.5067 16.2935 12.5067H19.8993C20.0808 12.5067 20.2275 12.6531 20.2275 12.8342C20.2275 13.0152 20.0808 13.1616 19.8993 13.1616H16.2935C16.1125 13.1616 15.9653 13.0152 15.9653 12.8342ZM15.9653 5.3586C15.9653 5.17754 16.1121 5.03111 16.2935 5.03111H19.8993C20.0808 5.03111 20.2275 5.17754 20.2275 5.3586C20.2275 5.53965 20.0808 5.68608 19.8993 5.68608H16.2935C16.1125 5.68608 15.9653 5.53918 15.9653 5.3586ZM15.9653 10.3425C15.9653 10.1614 16.1121 10.015 16.2935 10.015H19.8993C20.0808 10.015 20.2275 10.1614 20.2275 10.3425C20.2275 10.5235 20.0808 10.6699 19.8993 10.6699H16.2935C16.1125 10.6699 15.9653 10.523 15.9653 10.3425ZM14.0145 5.03111H8.6599C8.47846 5.03111 8.33172 5.17754 8.33172 5.3586V8.04632C8.33172 8.22737 8.47846 8.3738 8.6599 8.3738H14.0145C14.1959 8.3738 14.3427 8.22737 14.3427 8.04632V5.3586C14.3427 5.17754 14.1959 5.03111 14.0145 5.03111ZM13.6863 7.71836H8.98809V5.68561H13.6863V7.71836ZM14.2166 15.5682V18.2559C14.2166 18.437 14.3633 18.5834 14.5447 18.5834H19.8993C20.0808 18.5834 20.2275 18.437 20.2275 18.2559V15.5682C20.2275 15.3871 20.0808 15.2407 19.8993 15.2407H14.5447C14.3633 15.2407 14.2166 15.3876 14.2166 15.5682ZM14.8729 15.8957H19.5712V17.9284H14.8729V15.8957Z"
      fill="#242424"
    />
  </svg>
);

export const EnglishLanguage = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9199_3863)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.99226 20.7838C12.5216 23.554 16.0996 24.3905 19.6771 22.6601L22.6794 23.9999L21.6848 21.3143C25.0209 18.2813 24.4237 14.1127 21.9679 11.2707C21.8034 12.3631 21.4776 13.3986 21.0135 14.3559C20.354 15.717 19.4099 16.9276 18.253 17.9237C17.1323 18.8895 15.824 19.6467 14.398 20.1362C13.0391 20.6029 11.5509 20.836 9.99273 20.7838H9.99226ZM8.90945 10.2639H7.20788V11.2281H9.29194V12.6579H5.50679V6.62263H9.24976L9.03694 8.05243H7.20788V9.09431H8.90945V10.2639ZM13.4676 12.6579L11.9634 10.5145C11.9151 10.4459 11.8893 10.2889 11.878 10.0511H11.8438V12.6579H10.1427V6.62263H11.7421L13.2463 8.76653C13.2946 8.83464 13.3199 8.99214 13.3316 9.23H13.3654V6.62263H15.0669V12.6579H13.4676ZM10.5412 0.00631108L10.5515 0.0068432C13.3677 0.103688 15.8929 1.23975 17.6999 2.9984C19.5374 4.78684 20.6394 7.2186 20.5705 9.87067V9.87652C20.4998 12.5328 19.2693 14.8901 17.3376 16.554C15.4368 18.1914 12.8521 19.1571 10.0344 19.063C9.24554 19.0369 8.48288 18.9299 7.75679 18.7527C7.07476 18.5857 6.41991 18.3558 5.80069 18.0711L1.39679 20.0367L2.86819 16.064C1.98507 15.2025 1.27163 14.1925 0.778039 13.082C0.24507 11.8831 -0.0333677 10.5667 0.00319482 9.19275C0.0735073 6.53696 1.30398 4.17916 3.23569 2.51524C5.13648 0.877916 7.72163 -0.0878733 10.5393 0.00631108H10.5412ZM10.5196 1.15408L10.5093 1.15355C7.92788 1.06788 5.57054 1.94321 3.84601 3.42835C2.15288 4.88741 1.07476 6.93499 1.01382 9.22415C0.982414 10.4012 1.22241 11.5319 1.68132 12.5648C2.16366 13.6503 2.88788 14.6294 3.79304 15.4435L4.09444 15.7144L3.25866 17.9705L5.81288 16.8302L6.00366 16.9228C6.6196 17.2213 7.27726 17.4592 7.96679 17.6278C8.64179 17.7928 9.34351 17.8918 10.0621 17.9157C12.6444 18.0019 15.0027 17.1261 16.7273 15.6409C18.4209 14.1819 19.499 12.1348 19.5599 9.84512V9.83927C19.619 7.55171 18.6529 5.43868 17.0418 3.87107C15.4007 2.27419 13.0982 1.24242 10.5215 1.15408H10.5196Z"
        fill="#242424"
      />
    </g>
    <defs>
      <clipPath id="clip0_9199_3863">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const OtherLanguage = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9199_3860)">
      <path
        d="M12 4.125C10.4054 4.125 8.84659 4.59786 7.52072 5.48378C6.19485 6.3697 5.16146 7.62889 4.55122 9.10211C3.94099 10.5753 3.78133 12.1964 4.09242 13.7604C4.40352 15.3244 5.17139 16.761 6.29896 17.8885C7.42652 19.0161 8.86312 19.784 10.4271 20.0951C11.9911 20.4062 13.6122 20.2465 15.0854 19.6363C16.5586 19.026 17.8178 17.9927 18.7037 16.6668C19.5896 15.3409 20.0625 13.7821 20.0625 12.1875C20.0625 10.0492 19.2131 7.99846 17.7011 6.48645C16.189 4.97444 14.1383 4.125 12 4.125ZM17.8988 16.5C17.3641 16.1866 16.7986 15.9289 16.2113 15.7313C16.4916 14.6974 16.6452 13.6334 16.6688 12.5625H19.2938C19.2242 13.9833 18.7392 15.3524 17.8988 16.5ZM4.69688 12.5625H7.33125C7.354 13.6339 7.507 14.6986 7.78688 15.7331C7.1995 15.9308 6.63403 16.1884 6.09938 16.5019C5.25594 15.3546 4.76824 13.9847 4.69688 12.5625ZM6.10125 7.875C6.6359 8.18844 7.20138 8.44605 7.78875 8.64375C7.5084 9.67755 7.35477 10.7416 7.33125 11.8125H4.70625C4.77579 10.3917 5.26084 9.02265 6.10125 7.875ZM12.375 9.30375C13.423 9.27929 14.4645 9.13203 15.4781 8.865C15.7448 9.82583 15.8928 10.8157 15.9188 11.8125H12.375V9.30375ZM12.375 8.55375V4.91063C13.5563 5.13188 14.6044 6.375 15.2494 8.15063C14.31 8.39544 13.3455 8.53072 12.375 8.55375ZM11.625 4.91063V8.55375C10.6545 8.53072 9.68999 8.39544 8.75063 8.15063C9.39563 6.375 10.4438 5.13188 11.625 4.91063ZM11.625 9.30375V11.8125H8.08125C8.10724 10.8157 8.25522 9.82583 8.52188 8.865C9.53555 9.13203 10.577 9.27929 11.625 9.30375ZM8.08125 12.5625H11.625V15.0712C10.577 15.0957 9.53555 15.243 8.52188 15.51C8.25522 14.5492 8.10724 13.5593 8.08125 12.5625ZM11.625 15.8212V19.4644C10.4438 19.2431 9.39563 18 8.75063 16.2244C9.68999 15.9796 10.6545 15.8443 11.625 15.8212ZM12.375 19.4644V15.8212C13.3455 15.8443 14.31 15.9796 15.2494 16.2244C14.6044 18 13.5563 19.2431 12.375 19.4644ZM12.375 15.0712V12.5625H15.9188C15.8928 13.5593 15.7448 14.5492 15.4781 15.51C14.4645 15.243 13.423 15.0957 12.375 15.0712ZM16.6688 11.8125C16.646 10.7411 16.493 9.67637 16.2131 8.64188C16.8005 8.44418 17.366 8.18657 17.9006 7.87313C18.7474 9.01937 19.2384 10.3893 19.3125 11.8125H16.6688ZM17.4188 7.28437C16.9627 7.54362 16.483 7.75897 15.9863 7.9275C15.6659 6.95655 15.1475 6.06268 14.4638 5.3025C15.5974 5.7099 16.613 6.39063 17.4206 7.28437H17.4188ZM9.53438 5.30438C8.85065 6.06456 8.33221 6.95842 8.01188 7.92938C7.51509 7.76084 7.03544 7.5455 6.57938 7.28625C7.38649 6.39276 8.40144 5.71205 9.53438 5.30438ZM6.57938 17.0906C7.03544 16.8314 7.51509 16.616 8.01188 16.4475C8.33221 17.4185 8.85065 18.3123 9.53438 19.0725C8.40144 18.6648 7.38649 17.9841 6.57938 17.0906ZM14.4656 19.0706C15.1494 18.3104 15.6678 17.4166 15.9881 16.4456C16.4849 16.6142 16.9646 16.8295 17.4206 17.0887C16.6135 17.9822 15.5986 18.663 14.4656 19.0706Z"
        fill="#242424"
      />
      <path
        d="M12.0005 1.47883e-07C9.90464 0.000354802 7.84544 0.549614 6.02785 1.59311C4.21025 2.6366 2.69765 4.13793 1.64059 5.94768C0.583531 7.75742 0.018887 9.81245 0.002858 11.9082C-0.013171 14.004 0.519974 16.0674 1.54923 17.8931L0.0136014 23.5181C-0.00309737 23.5743 -0.0064056 23.6336 0.00394198 23.6912C0.0142896 23.7489 0.0380051 23.8033 0.073187 23.8502C0.108369 23.897 0.154038 23.935 0.206534 23.961C0.259029 23.987 0.31689 24.0004 0.375476 24C0.407817 24.0003 0.440025 23.9958 0.471101 23.9869L6.16923 22.4869C7.77078 23.3777 9.55509 23.8899 11.3853 23.9841C13.2155 24.0784 15.043 23.7522 16.7276 23.0305C18.4121 22.3089 19.9091 21.211 21.1035 19.8211C22.2979 18.4312 23.1581 16.7861 23.6182 15.0122C24.0782 13.2382 24.1258 11.3825 23.7573 9.58726C23.3888 7.79205 22.6141 6.10509 21.4925 4.65576C20.3709 3.20644 18.9322 2.03326 17.2868 1.22622C15.6415 0.419177 13.8331 -0.000287541 12.0005 1.47883e-07ZM12.0005 23.25C10.0372 23.2466 8.1089 22.7295 6.40735 21.75C6.3502 21.7176 6.28554 21.7008 6.21985 21.7012C6.18765 21.7013 6.15556 21.7051 6.12423 21.7125L0.907976 23.0963L2.31235 17.94C2.32541 17.8921 2.32882 17.842 2.32238 17.7928C2.31594 17.7436 2.29979 17.6961 2.27485 17.6531C1.02969 15.5108 0.52668 13.0172 0.843928 10.5597C1.16118 8.10213 2.28093 5.81808 4.02933 4.06215C5.77773 2.30622 8.05695 1.17667 10.5131 0.848872C12.9693 0.521072 15.4649 1.01336 17.6126 2.24932C19.7603 3.48527 21.4399 5.39572 22.3905 7.68405C23.3412 9.97239 23.5097 12.5106 22.8699 14.9045C22.2302 17.2984 20.818 19.4142 18.8525 20.9232C16.8871 22.4323 14.4784 23.2502 12.0005 23.25Z"
        fill="#242424"
      />
    </g>
    <defs>
      <clipPath id="clip0_9199_3860">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AddProjectIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.4998 2H7.70977L6.85977 1.15L6.50977 1H1.50977L1.00977 1.5V12.5L1.50977 13H6.99977V12H1.98977V6H6.47977L6.82977 5.85L7.68977 4.99H13.9998V6.49L13.9988 7H15.0098V2.5L14.4998 2ZM13.9898 4H7.48977L7.13977 4.15L6.27977 5.01H1.99977V2.01H6.28977L7.13977 2.86L7.49977 3.01H13.9998L13.9898 4ZM12.9998 16H11.9998V13H8.99977V12H11.9998V9H12.9998V12H15.9998V13H12.9998V16Z"
      fill="#242424"
    />
  </svg>
);

export const DeleteAllIcon = ({ color }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5 5.5L19.098 12.006M4.5 5.5L5.105 15.525C5.259 18.092 5.337 19.375 5.979 20.299C6.296 20.755 6.705 21.141 7.179 21.43C7.85 21.84 8.681 21.963 10 22M20 15L13 22M20 22L13 15M3 5.5H21M16.056 5.5L15.373 4.092C14.92 3.156 14.693 2.689 14.302 2.397C14.2151 2.33232 14.1232 2.27479 14.027 2.225C13.594 2 13.074 2 12.035 2C10.969 2 10.436 2 9.995 2.234C9.89752 2.28621 9.80453 2.34642 9.717 2.414C9.322 2.717 9.101 3.202 8.659 4.171L8.053 5.5"
      stroke={color ?? '#242424'}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const DeleteMediaIcon = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5 5.5L19.098 12.006M4.5 5.5L5.105 15.525C5.259 18.092 5.337 19.375 5.979 20.299C6.296 20.755 6.705 21.141 7.179 21.43C7.85 21.84 8.681 21.963 10 22M3 5.5H21M16.056 5.5L15.373 4.092C14.92 3.156 14.693 2.689 14.302 2.397C14.2151 2.33232 14.1232 2.27479 14.027 2.225C13.594 2 13.074 2 12.035 2C10.969 2 10.436 2 9.995 2.234C9.89752 2.28621 9.80453 2.34642 9.717 2.414C9.322 2.717 9.101 3.202 8.659 4.171L8.053 5.5"
      stroke="#242424"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <g clip-path="url(#clip0_9425_4074)">
      <path
        d="M22 17.2715V21.6562C22 21.8223 21.9642 21.972 21.8926 22.1055C21.821 22.2389 21.7249 22.3529 21.6045 22.4473C21.484 22.5417 21.3506 22.6165 21.2041 22.6719C21.0576 22.7272 20.9062 22.7533 20.75 22.75C20.597 22.75 20.4456 22.724 20.2959 22.6719C20.1462 22.6198 20.0127 22.5465 19.8955 22.4521C19.7783 22.3577 19.6839 22.2422 19.6123 22.1055C19.5407 21.9688 19.5033 21.819 19.5 21.6562C19.5 21.4902 19.5358 21.3405 19.6074 21.207C19.679 21.0736 19.7751 20.958 19.8955 20.8604C20.016 20.7627 20.1494 20.6895 20.2959 20.6406C20.4424 20.5918 20.5938 20.5658 20.75 20.5625C20.9648 20.5625 21.1732 20.613 21.375 20.7139V18.0723L18.25 18.8535V22.2812C18.25 22.4473 18.2142 22.597 18.1426 22.7305C18.071 22.8639 17.9749 22.9779 17.8545 23.0723C17.734 23.1667 17.6006 23.2415 17.4541 23.2969C17.3076 23.3522 17.1562 23.3783 17 23.375C16.847 23.375 16.6956 23.349 16.5459 23.2969C16.3962 23.2448 16.2627 23.1715 16.1455 23.0771C16.0283 22.9827 15.9339 22.8672 15.8623 22.7305C15.7907 22.5938 15.7533 22.444 15.75 22.2812C15.75 22.1152 15.7858 21.9655 15.8574 21.832C15.929 21.6986 16.0251 21.583 16.1455 21.4854C16.266 21.3877 16.3994 21.3145 16.5459 21.2656C16.6924 21.2168 16.8438 21.1908 17 21.1875C17.2148 21.1875 17.4232 21.238 17.625 21.3389V18.3652L22 17.2715ZM17 22.75C17.0651 22.75 17.1335 22.7402 17.2051 22.7207C17.2767 22.7012 17.3451 22.6719 17.4102 22.6328C17.4753 22.5938 17.5257 22.5449 17.5615 22.4863C17.5973 22.4277 17.6185 22.3594 17.625 22.2812C17.625 22.2031 17.6055 22.1348 17.5664 22.0762C17.5273 22.0176 17.4753 21.9688 17.4102 21.9297C17.3451 21.8906 17.2783 21.8613 17.21 21.8418C17.1416 21.8223 17.0716 21.8125 17 21.8125C16.9349 21.8125 16.8665 21.8223 16.7949 21.8418C16.7233 21.8613 16.6549 21.8906 16.5898 21.9297C16.5247 21.9688 16.4743 22.0176 16.4385 22.0762C16.4027 22.1348 16.3815 22.2031 16.375 22.2812C16.375 22.3594 16.3945 22.4277 16.4336 22.4863C16.4727 22.5449 16.5247 22.5938 16.5898 22.6328C16.6549 22.6719 16.7217 22.7012 16.79 22.7207C16.8584 22.7402 16.9284 22.75 17 22.75ZM20.75 22.125C20.8151 22.125 20.8835 22.1152 20.9551 22.0957C21.0267 22.0762 21.0951 22.0469 21.1602 22.0078C21.2253 21.9688 21.2757 21.9199 21.3115 21.8613C21.3473 21.8027 21.3685 21.7344 21.375 21.6562C21.375 21.5781 21.3555 21.5098 21.3164 21.4512C21.2773 21.3926 21.2253 21.3438 21.1602 21.3047C21.0951 21.2656 21.0283 21.2363 20.96 21.2168C20.8916 21.1973 20.8216 21.1875 20.75 21.1875C20.6849 21.1875 20.6165 21.1973 20.5449 21.2168C20.4733 21.2363 20.4049 21.2656 20.3398 21.3047C20.2747 21.3438 20.2243 21.3926 20.1885 21.4512C20.1527 21.5098 20.1315 21.5781 20.125 21.6562C20.125 21.7344 20.1445 21.8027 20.1836 21.8613C20.2227 21.9199 20.2747 21.9688 20.3398 22.0078C20.4049 22.0469 20.4717 22.0762 20.54 22.0957C20.6084 22.1152 20.6784 22.125 20.75 22.125ZM13.875 17.125H13.25V16.5H13.875V17.125ZM13.25 17.75H13.875V18.375H13.25V17.75ZM17.625 16.5H18.25V17.125H17.625V16.5ZM17 20.25H12V14.625H19.5V17.125L18.875 17.2812V15.25H18.25V15.875H17.625V15.25H13.875V15.875H13.25V15.25H12.625V19.625H13.25V19H13.875V19.625H17V20.25Z"
        fill="#242424"
      />
    </g>
    <defs>
      <clipPath id="clip0_9425_4074">
        <rect
          width="10"
          height="10"
          fill="white"
          transform="translate(12 14)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const AiIcon = ({ color }: { color: string }) => (
  <svg
    width="16.5"
    height="16.5"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="33" height="33" rx="4" fill={color} />
    <path
      d="M4.024 24L11.68 7.08H14.2L21.856 24H18.736L17.056 20.088H8.8L7.144 24H4.024ZM12.904 10.416L9.856 17.64H16L12.952 10.416H12.904ZM23.7074 24V7.08H26.7794V24H23.7074Z"
      fill={
        color === '#5579F2'
          ? 'white'
          : color === '#242424'
          ? '#bdbdbd'
          : '#5579F2'
      }
    />
  </svg>
);

export const NoOfVideo = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.1647 4.14819H5.83527C3.34025 4.14819 1.31763 6.2707 1.31763 8.88893V23.1112C1.31763 25.7294 3.34025 27.8519 5.83527 27.8519H26.1647C28.6597 27.8519 30.6823 25.7294 30.6823 23.1112V8.88893C30.6823 6.2707 28.6597 4.14819 26.1647 4.14819Z"
      stroke="#FA9D31"
      stroke-width="1.71429"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.1825 21.4981V11.5426C12.1778 11.3745 12.2169 11.2083 12.2955 11.0617C12.3741 10.9152 12.4893 10.794 12.6288 10.7111C12.7682 10.6282 12.9265 10.5868 13.0867 10.5913C13.2468 10.5958 13.4028 10.646 13.5378 10.7367L21.6696 15.7144C21.8054 15.7981 21.9181 15.9176 21.9964 16.061C22.0747 16.2045 22.1159 16.3669 22.1159 16.5322C22.1159 16.6975 22.0747 16.86 21.9964 17.0034C21.9181 17.1469 21.8054 17.2663 21.6696 17.35L13.5378 22.3278C13.3999 22.4114 13.2433 22.4552 13.084 22.4548C12.9247 22.4544 12.7683 22.4099 12.6307 22.3257C12.4931 22.2414 12.3792 22.1205 12.3005 21.9752C12.2218 21.8299 12.1811 21.6653 12.1825 21.4981V21.4981Z"
      stroke="#FA9D31"
      stroke-width="1.71429"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const TextOpenEnd = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={26} height={26} fill="none">
    <mask
      id="a"
      width={26}
      height={26}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path fill="#fff" d="M25.683 0H.317v25.917h25.366V0Z" />
    </mask>
    <g fill="#A29CFF" mask="url(#a)">
      <path d="M17.65 9.203c-.142 0-.281.014-.422.021v-7.97c0-.332-.134-.651-.372-.886A1.275 1.275 0 0 0 15.96 0H3.873a.844.844 0 0 0-.597.244L.564 2.928a.827.827 0 0 0-.247.59v16.98c0 .332.134.651.372.887.237.235.56.367.896.367h9.528a8.01 8.01 0 0 0 3.118 2.58 8.102 8.102 0 0 0 7.844-.554 7.972 7.972 0 0 0 2.716-2.992 7.874 7.874 0 0 0-.282-7.776 7.99 7.99 0 0 0-2.926-2.791 8.095 8.095 0 0 0-3.932-1.016ZM3.278 1.427V2.51c0 .11-.045.217-.124.296a.425.425 0 0 1-.3.122H1.76l1.516-1.501ZM1.585 20.916a.425.425 0 0 1-.298-.123.416.416 0 0 1-.124-.296V3.765h1.69c.337 0 .66-.132.898-.368.237-.235.371-.554.371-.887V.837h11.837a.416.416 0 0 1 .423.418v8.057a8.065 8.065 0 0 0-3.497 1.445 7.957 7.957 0 0 0-2.435 2.873 7.867 7.867 0 0 0 .129 7.286H1.585Zm11.444 1.673h9.243a7.207 7.207 0 0 1-4.621 1.673 7.207 7.207 0 0 1-4.622-1.673Zm10.091-.837h-.82v-5.02a.416.416 0 0 0-.123-.295.425.425 0 0 0-.722.296v5.02h-.845v-3.765a.416.416 0 0 0-.124-.296.425.425 0 0 0-.598 0 .416.416 0 0 0-.124.296v3.764h-.845v-3.346a.416.416 0 0 0-.124-.296.425.425 0 0 0-.598 0 .416.416 0 0 0-.124.296v3.346h-.845V17.57a.416.416 0 0 0-.124-.296.425.425 0 0 0-.722.296v4.183h-.845v-5.02a.416.416 0 0 0-.124-.295.425.425 0 0 0-.722.296v5.02h-.845v-4.184a.416.416 0 0 0-.124-.296.425.425 0 0 0-.722.296v4.183h-.82a7.045 7.045 0 0 1-1.056-7.594 7.135 7.135 0 0 1 2.653-3.009 7.244 7.244 0 0 1 7.747 0 7.135 7.135 0 0 1 2.652 3.01 7.045 7.045 0 0 1-1.056 7.593Z" />
      <path d="M7.081 3.765h4.228c.112 0 .22-.044.299-.123a.416.416 0 0 0-.299-.714H7.081a.425.425 0 0 0-.298.123.416.416 0 0 0 0 .591c.079.079.186.123.298.123ZM2.854 6.693h11.838c.112 0 .22-.044.299-.123a.416.416 0 0 0-.3-.714H2.855a.425.425 0 0 0-.299.122.416.416 0 0 0 .3.715ZM2.854 8.785h11.838c.112 0 .22-.045.299-.123a.416.416 0 0 0-.3-.714H2.855a.425.425 0 0 0-.299.122.416.416 0 0 0 .3.715ZM2.854 10.875h8.455a.416.416 0 1 0 0-.837H2.854a.425.425 0 0 0-.299.123.416.416 0 0 0 0 .592c.08.078.187.122.3.122ZM2.854 12.967h6.764c.112 0 .22-.044.3-.122a.416.416 0 0 0-.3-.715H2.854a.425.425 0 0 0-.299.123.416.416 0 0 0 .3.714ZM8.773 14.221H2.854a.425.425 0 0 0-.299.123.416.416 0 0 0 .3.714h5.918c.112 0 .22-.044.299-.123a.416.416 0 0 0-.3-.714ZM2.854 17.152H8.35a.416.416 0 1 0 0-.837H2.854a.425.425 0 0 0-.299.123.416.416 0 0 0 0 .592c.08.078.187.122.3.122ZM8.773 18.406H2.854a.425.425 0 0 0-.299.123.416.416 0 0 0 0 .591c.08.079.187.123.3.123h5.918a.416.416 0 1 0 0-.837ZM21.454 12.967h-1.268a.425.425 0 0 0-.299.122.416.416 0 0 0 0 .592c.08.078.187.122.3.122h.184l-1.234 1.016a1.248 1.248 0 0 0-1.465.13l-.89-.506a1.243 1.243 0 0 0-.282-1.053 1.267 1.267 0 0 0-1.008-.439 1.28 1.28 0 0 0-.974.506 1.25 1.25 0 0 0-.208 1.07l-1.545 1.02a.418.418 0 0 0-.117.58.423.423 0 0 0 .586.116l1.545-1.02a1.254 1.254 0 0 0 1.58-.055l.89.506a1.242 1.242 0 0 0 .306 1.076 1.268 1.268 0 0 0 1.053.408 1.276 1.276 0 0 0 .963-.585 1.248 1.248 0 0 0 .11-1.113l1.35-1.113v.293a.425.425 0 0 0 .846 0v-1.255a.416.416 0 0 0-.123-.296.425.425 0 0 0-.3-.122Zm-5.918 1.673a.425.425 0 0 1-.39-.258.414.414 0 0 1 .09-.456.424.424 0 0 1 .723.296.416.416 0 0 1-.124.295.425.425 0 0 1-.3.123Zm2.96 1.673a.427.427 0 0 1-.391-.258.415.415 0 0 1 .308-.57.427.427 0 0 1 .434.177.416.416 0 0 1-.053.529.426.426 0 0 1-.299.122Z" />
    </g>
  </svg>
);

export const NumberOfRespondent = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9604_4159)">
      <path
        d="M14.9166 14.4167C17.1666 14.4167 18.9166 12.5834 18.9166 10.3334C18.9166 8.08337 17.0833 6.33337 14.8333 6.33337C12.5833 6.33337 10.8333 8.16671 10.8333 10.3334C10.8333 12.5834 12.6666 14.4167 14.9166 14.4167ZM14.8333 8.00004C14.9166 8.00004 14.9166 8.00004 14.8333 8.00004C16.1666 8.00004 17.2499 9.08337 17.2499 10.4167C17.2499 11.75 16.1666 12.75 14.8333 12.75C13.4999 12.75 12.4999 11.6667 12.4999 10.4167C12.4999 9.08337 13.5833 8.00004 14.8333 8.00004Z"
        fill="#589BFF"
      />
      <path
        d="M27.25 13.9166C25.6667 12.5 23.5833 11.75 21.4167 11.8333H20.75C20.5833 12.5 20.3333 13.0833 20 13.5833C20.5 13.5 20.9167 13.5 21.4167 13.5C23 13.4166 24.5833 13.9166 25.8333 14.8333V20.8333H27.5V14.1666L27.25 13.9166Z"
        fill="#589BFF"
      />
      <path
        d="M19.4999 6.50004C19.9166 5.50004 21.0833 5.00004 22.1666 5.41671C23.1666 5.83337 23.6666 7.00004 23.2499 8.08337C22.9166 8.83337 22.1666 9.33337 21.4166 9.33337C21.2499 9.33337 20.9999 9.33337 20.8333 9.25004C20.9166 9.66671 20.9166 10.0834 20.9166 10.4167V10.9167C21.0833 10.9167 21.2499 11 21.4166 11C23.4999 11 25.1666 9.33337 25.1666 7.33337C25.1666 5.25004 23.4999 3.58337 21.4999 3.58337C20.1666 3.58337 18.9999 4.25004 18.3333 5.41671C18.7499 5.66671 19.1666 6.00004 19.4999 6.50004Z"
        fill="#589BFF"
      />
      <path
        d="M10 13.6667C9.66667 13.1667 9.41667 12.5833 9.25 11.9167H8.58333C6.41667 11.8333 4.33333 12.5833 2.75 13.9167L2.5 14.1667V20.8333H4.16667V14.8333C5.5 13.9167 7 13.4167 8.58333 13.5C9.08333 13.5 9.58333 13.5833 10 13.6667Z"
        fill="#589BFF"
      />
      <path
        d="M8.58322 10.9166C8.74989 10.9166 8.91655 10.9166 9.08322 10.8333V10.3333C9.08322 9.91664 9.08322 9.49997 9.16656 9.16664C8.99989 9.24997 8.74989 9.24997 8.58322 9.24997C7.49989 9.24997 6.58322 8.3333 6.58322 7.24997C6.58322 6.16664 7.49989 5.24997 8.58322 5.24997C9.41656 5.24997 10.1666 5.74997 10.4999 6.49997C10.8332 6.0833 11.3332 5.66664 11.7499 5.3333C10.6666 3.5833 8.41656 2.99997 6.66656 4.0833C4.91656 5.16664 4.33322 7.41664 5.41656 9.16664C6.08322 10.25 7.24989 10.9166 8.58322 10.9166Z"
        fill="#589BFF"
      />
      <path
        d="M21.7499 18.9167L21.5833 18.6667C19.9166 16.8333 17.5833 15.75 15.0833 15.8333C12.5833 15.75 10.1666 16.8333 8.49992 18.6667L8.33325 18.9167V25.25C8.33325 26 8.91659 26.6667 9.74992 26.6667H20.4166C21.1666 26.6667 21.8333 26 21.8333 25.25V18.9167H21.7499ZM20.0833 25H9.99992V19.5C11.3333 18.1667 13.1666 17.5 15.0833 17.5C16.9166 17.4167 18.7499 18.1667 20.0833 19.5V25Z"
        fill="#589BFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_9604_4159">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AudioInSec = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.66675 5.99996L10.0001 2.66663M27.3334 5.99996L22.0001 2.66663"
      stroke="#FF44A1"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0001 6.93864C12.5214 5.48343 15.4858 4.9944 18.3409 5.56264C21.1961 6.13089 23.7473 7.71766 25.5193 10.0274C27.2914 12.3371 28.1633 15.2122 27.9728 18.1171C27.7823 21.022 26.5423 23.7586 24.4838 25.8171C22.4253 27.8756 19.6887 29.1156 16.7838 29.3061C13.8789 29.4966 11.0038 28.6246 8.69411 26.8526C6.38441 25.0805 4.79764 22.5293 4.22939 19.6742C3.66115 16.819 4.15018 13.8547 5.60539 11.3333"
      stroke="#FF44A1"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M20.5117 16.207C20.5117 16.1469 20.4625 16.0977 20.4023 16.0977H19.582C19.5219 16.0977 19.4727 16.1469 19.4727 16.207C19.4727 18.1252 17.9182 19.6797 16 19.6797C14.0818 19.6797 12.5273 18.1252 12.5273 16.207C12.5273 16.1469 12.4781 16.0977 12.418 16.0977H11.5977C11.5375 16.0977 11.4883 16.1469 11.4883 16.207C11.4883 18.5135 13.2191 20.4166 15.4531 20.6859V22.0859H13.4666C13.2793 22.0859 13.1289 22.2814 13.1289 22.5234V23.0156C13.1289 23.0758 13.1672 23.125 13.2137 23.125H18.7863C18.8328 23.125 18.8711 23.0758 18.8711 23.0156V22.5234C18.8711 22.2814 18.7207 22.0859 18.5334 22.0859H16.4922V20.6928C18.7521 20.4467 20.5117 18.5326 20.5117 16.207ZM16 18.5312C17.2838 18.5312 18.3242 17.5031 18.3242 16.2344V13.1719C18.3242 11.9031 17.2838 10.875 16 10.875C14.7162 10.875 13.6758 11.9031 13.6758 13.1719V16.2344C13.6758 17.5031 14.7162 18.5312 16 18.5312ZM14.7148 13.1719C14.7148 12.4801 15.2877 11.9141 16 11.9141C16.7123 11.9141 17.2852 12.4801 17.2852 13.1719V16.2344C17.2852 16.9262 16.7123 17.4922 16 17.4922C15.2877 17.4922 14.7148 16.9262 14.7148 16.2344V13.1719Z"
      fill="#FF44A1"
    />
  </svg>
);

export const NoOfAudio = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.668 13.3008C24.668 13.1719 24.5625 13.0664 24.4336 13.0664H22.6758C22.5469 13.0664 22.4414 13.1719 22.4414 13.3008C22.4414 17.4111 19.1104 20.7422 15 20.7422C10.8896 20.7422 7.55859 17.4111 7.55859 13.3008C7.55859 13.1719 7.45313 13.0664 7.32422 13.0664H5.56641C5.4375 13.0664 5.33203 13.1719 5.33203 13.3008C5.33203 18.2432 9.04102 22.3213 13.8281 22.8984V25.8984H9.57129C9.16992 25.8984 8.84766 26.3174 8.84766 26.8359V27.8906C8.84766 28.0195 8.92969 28.125 9.0293 28.125H20.9707C21.0703 28.125 21.1523 28.0195 21.1523 27.8906V26.8359C21.1523 26.3174 20.8301 25.8984 20.4287 25.8984H16.0547V22.9131C20.8975 22.3857 24.668 18.2842 24.668 13.3008ZM15 18.2812C17.751 18.2812 19.9805 16.0781 19.9805 13.3594V6.79688C19.9805 4.07812 17.751 1.875 15 1.875C12.249 1.875 10.0195 4.07812 10.0195 6.79688V13.3594C10.0195 16.0781 12.249 18.2812 15 18.2812ZM12.2461 6.79688C12.2461 5.31445 13.4736 4.10156 15 4.10156C16.5264 4.10156 17.7539 5.31445 17.7539 6.79688V13.3594C17.7539 14.8418 16.5264 16.0547 15 16.0547C13.4736 16.0547 12.2461 14.8418 12.2461 13.3594V6.79688Z"
      fill="#FFCA2D"
    />
  </svg>
);

export const VideoInSec = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.5174 14.58C19.9507 15.7493 20.6667 16.3333 20.6667 17.3333C20.6667 18.3333 19.9507 18.9173 18.5174 20.0866C18.1214 20.4093 17.7294 20.7133 17.3681 20.9666C17.0521 21.1893 16.6934 21.4186 16.3227 21.644C14.8921 22.5133 14.1774 22.948 13.5361 22.4666C12.8961 21.9866 12.8374 20.9786 12.7201 18.9626C12.6881 18.3933 12.6667 17.8346 12.6667 17.3333C12.6667 16.832 12.6881 16.2733 12.7201 15.704C12.8374 13.688 12.8961 12.6813 13.5361 12.2C14.1774 11.7186 14.8934 12.1533 16.3227 13.0226C16.6934 13.248 17.0521 13.4773 17.3681 13.7C17.7281 13.9533 18.1214 14.2573 18.5174 14.58Z"
      stroke="#BEAA00"
      strokeWidth="1.5"
    />
    <path
      d="M4.66675 5.99996L10.0001 2.66663M27.3334 5.99996L22.0001 2.66663"
      stroke="#BEAA00"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0001 6.93864C12.5214 5.48343 15.4858 4.9944 18.3409 5.56264C21.1961 6.13089 23.7473 7.71766 25.5193 10.0274C27.2914 12.3371 28.1633 15.2122 27.9728 18.1171C27.7823 21.022 26.5423 23.7586 24.4838 25.8171C22.4253 27.8756 19.6887 29.1156 16.7838 29.3061C13.8789 29.4966 11.0038 28.6246 8.69411 26.8526C6.38441 25.0805 4.79764 22.5293 4.22939 19.6742C3.66115 16.819 4.15018 13.8547 5.60539 11.3333"
      stroke="#BEAA00"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const MoneyIcon = ({ size }: IconProps) => (
  <svg
    width={size ?? '36'}
    height={size ?? '36'}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.3333 21.3334C21.3333 19.86 17.1546 18.6667 11.9999 18.6667M21.3333 21.3334C21.3333 22.8067 17.1546 24 11.9999 24C6.84525 24 2.66659 22.8067 2.66659 21.3334M21.3333 21.3334V27.916C21.3333 29.4347 17.1546 30.6667 11.9999 30.6667C6.84525 30.6667 2.66659 29.436 2.66659 27.916V21.3334M21.3333 21.3334C26.4319 21.3334 30.6666 20.0174 30.6666 18.6667V5.33335M11.9999 18.6667C6.84525 18.6667 2.66659 19.86 2.66659 21.3334M11.9999 18.6667C6.10925 18.6667 1.33325 17.3507 1.33325 16V9.33335M11.9999 6.66669C6.10925 6.66669 1.33325 7.86002 1.33325 9.33335M1.33325 9.33335C1.33325 10.8067 6.10925 12 11.9999 12C11.9999 13.3507 16.3373 14.6667 21.4359 14.6667C26.5346 14.6667 30.6666 13.3507 30.6666 12M30.6666 5.33335C30.6666 3.86002 26.5333 2.66669 21.4359 2.66669C16.3386 2.66669 12.2053 3.86002 12.2053 5.33335M30.6666 5.33335C30.6666 6.80669 26.5333 8.00002 21.4359 8.00002C16.3386 8.00002 12.2053 6.80669 12.2053 5.33335M12.2053 5.33335V18.888"
      stroke="#11b503"
    />
  </svg>
);

export const MediaTotalTimeIcon = ({ size, color }: IconProps) => (
  <svg
    width={size ?? '32'}
    height={size ?? '32'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 7.85156V18.375C24 18.7734 23.9141 19.1328 23.7422 19.4531C23.5703 19.7734 23.3398 20.0469 23.0508 20.2734C22.7617 20.5 22.4414 20.6797 22.0898 20.8125C21.7383 20.9453 21.375 21.0078 21 21C20.6328 21 20.2695 20.9375 19.9102 20.8125C19.5508 20.6875 19.2305 20.5117 18.9492 20.2852C18.668 20.0586 18.4414 19.7812 18.2695 19.4531C18.0977 19.125 18.0078 18.7656 18 18.375C18 17.9766 18.0859 17.6172 18.2578 17.2969C18.4297 16.9766 18.6602 16.6992 18.9492 16.4648C19.2383 16.2305 19.5586 16.0547 19.9102 15.9375C20.2617 15.8203 20.625 15.7578 21 15.75C21.5156 15.75 22.0156 15.8711 22.5 16.1133V9.77344L15 11.6484V19.875C15 20.2734 14.9141 20.6328 14.7422 20.9531C14.5703 21.2734 14.3398 21.5469 14.0508 21.7734C13.7617 22 13.4414 22.1797 13.0898 22.3125C12.7383 22.4453 12.375 22.5078 12 22.5C11.6328 22.5 11.2695 22.4375 10.9102 22.3125C10.5508 22.1875 10.2305 22.0117 9.94922 21.7852C9.66797 21.5586 9.44141 21.2812 9.26953 20.9531C9.09766 20.625 9.00781 20.2656 9 19.875C9 19.4766 9.08594 19.1172 9.25781 18.7969C9.42969 18.4766 9.66016 18.1992 9.94922 17.9648C10.2383 17.7305 10.5586 17.5547 10.9102 17.4375C11.2617 17.3203 11.625 17.2578 12 17.25C12.5156 17.25 13.0156 17.3711 13.5 17.6133V10.4766L24 7.85156ZM12 21C12.1562 21 12.3203 20.9766 12.4922 20.9297C12.6641 20.8828 12.8281 20.8125 12.9844 20.7188C13.1406 20.625 13.2617 20.5078 13.3477 20.3672C13.4336 20.2266 13.4844 20.0625 13.5 19.875C13.5 19.6875 13.4531 19.5234 13.3594 19.3828C13.2656 19.2422 13.1406 19.125 12.9844 19.0312C12.8281 18.9375 12.668 18.8672 12.5039 18.8203C12.3398 18.7734 12.1719 18.75 12 18.75C11.8438 18.75 11.6797 18.7734 11.5078 18.8203C11.3359 18.8672 11.1719 18.9375 11.0156 19.0312C10.8594 19.125 10.7383 19.2422 10.6523 19.3828C10.5664 19.5234 10.5156 19.6875 10.5 19.875C10.5 20.0625 10.5469 20.2266 10.6406 20.3672C10.7344 20.5078 10.8594 20.625 11.0156 20.7188C11.1719 20.8125 11.332 20.8828 11.4961 20.9297C11.6602 20.9766 11.8281 21 12 21ZM21 19.5C21.1562 19.5 21.3203 19.4766 21.4922 19.4297C21.6641 19.3828 21.8281 19.3125 21.9844 19.2188C22.1406 19.125 22.2617 19.0078 22.3477 18.8672C22.4336 18.7266 22.4844 18.5625 22.5 18.375C22.5 18.1875 22.4531 18.0234 22.3594 17.8828C22.2656 17.7422 22.1406 17.625 21.9844 17.5312C21.8281 17.4375 21.668 17.3672 21.5039 17.3203C21.3398 17.2734 21.1719 17.25 21 17.25C20.8438 17.25 20.6797 17.2734 20.5078 17.3203C20.3359 17.3672 20.1719 17.4375 20.0156 17.5312C19.8594 17.625 19.7383 17.7422 19.6523 17.8828C19.5664 18.0234 19.5156 18.1875 19.5 18.375C19.5 18.5625 19.5469 18.7266 19.6406 18.8672C19.7344 19.0078 19.8594 19.125 20.0156 19.2188C20.1719 19.3125 20.332 19.3828 20.4961 19.4297C20.6602 19.4766 20.8281 19.5 21 19.5ZM4.5 7.5H3V6H4.5V7.5ZM3 9H4.5V10.5H3V9ZM13.5 6H15V7.5H13.5V6ZM12 15H0V1.5H18V7.5L16.5 7.875V3H15V4.5H13.5V3H4.5V4.5H3V3H1.5V13.5H3V12H4.5V13.5H12V15Z"
      fill="#FF44A1"
    />
  </svg>
);

export const TotalCreditIcon = ({ size, color }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M11 4V10C11 11.105 8.985 12 6.5 12C4.015 12 2 11.105 2 10V4"
      stroke="#FF6669"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11 7C11 8.105 8.985 9 6.5 9C4.015 9 2 8.105 2 7M11 4C11 5.105 8.985 6 6.5 6C4.015 6 2 5.105 2 4C2 2.895 4.015 2 6.5 2C8.985 2 11 2.895 11 4Z"
      stroke="#FF6669"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V8M8 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V16"
      stroke="#FF6669"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.5 22C15.0118 22 13 19.9882 13 17.5C13 15.0118 15.0118 13 17.5 13C19.9882 13 22 15.0118 22 17.5C22 19.9882 19.9882 22 17.5 22ZM17.5 13.5294C15.3029 13.5294 13.5294 15.3029 13.5294 17.5C13.5294 19.6971 15.3029 21.4706 17.5 21.4706C19.6971 21.4706 21.4706 19.6971 21.4706 17.5C21.4706 15.3029 19.6971 13.5294 17.5 13.5294Z"
      fill="#FF6669"
    />
    <path
      d="M15 17.5C15 17.2239 15.2239 17 15.5 17H19.5C19.7761 17 20 17.2239 20 17.5V17.5C20 17.7761 19.7761 18 19.5 18H15.5C15.2239 18 15 17.7761 15 17.5V17.5Z"
      fill="#FF6669"
    />
  </svg>
);
export const NumberOfRespondentIcon = () => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9604_4159)">
      <path
        d="M14.9166 14.4167C17.1666 14.4167 18.9166 12.5834 18.9166 10.3334C18.9166 8.08337 17.0833 6.33337 14.8333 6.33337C12.5833 6.33337 10.8333 8.16671 10.8333 10.3334C10.8333 12.5834 12.6666 14.4167 14.9166 14.4167ZM14.8333 8.00004C14.9166 8.00004 14.9166 8.00004 14.8333 8.00004C16.1666 8.00004 17.2499 9.08337 17.2499 10.4167C17.2499 11.75 16.1666 12.75 14.8333 12.75C13.4999 12.75 12.4999 11.6667 12.4999 10.4167C12.4999 9.08337 13.5833 8.00004 14.8333 8.00004Z"
        fill="#FA9D31"
      />
      <path
        d="M27.25 13.9166C25.6667 12.5 23.5833 11.75 21.4167 11.8333H20.75C20.5833 12.5 20.3333 13.0833 20 13.5833C20.5 13.5 20.9167 13.5 21.4167 13.5C23 13.4166 24.5833 13.9166 25.8333 14.8333V20.8333H27.5V14.1666L27.25 13.9166Z"
        fill="#FA9D31"
      />
      <path
        d="M19.4999 6.50004C19.9166 5.50004 21.0833 5.00004 22.1666 5.41671C23.1666 5.83337 23.6666 7.00004 23.2499 8.08337C22.9166 8.83337 22.1666 9.33337 21.4166 9.33337C21.2499 9.33337 20.9999 9.33337 20.8333 9.25004C20.9166 9.66671 20.9166 10.0834 20.9166 10.4167V10.9167C21.0833 10.9167 21.2499 11 21.4166 11C23.4999 11 25.1666 9.33337 25.1666 7.33337C25.1666 5.25004 23.4999 3.58337 21.4999 3.58337C20.1666 3.58337 18.9999 4.25004 18.3333 5.41671C18.7499 5.66671 19.1666 6.00004 19.4999 6.50004Z"
        fill="#FA9D31"
      />
      <path
        d="M10 13.6667C9.66667 13.1667 9.41667 12.5833 9.25 11.9167H8.58333C6.41667 11.8333 4.33333 12.5833 2.75 13.9167L2.5 14.1667V20.8333H4.16667V14.8333C5.5 13.9167 7 13.4167 8.58333 13.5C9.08333 13.5 9.58333 13.5833 10 13.6667Z"
        fill="#FA9D31"
      />
      <path
        d="M8.58322 10.9166C8.74989 10.9166 8.91655 10.9166 9.08322 10.8333V10.3333C9.08322 9.91664 9.08322 9.49997 9.16656 9.16664C8.99989 9.24997 8.74989 9.24997 8.58322 9.24997C7.49989 9.24997 6.58322 8.3333 6.58322 7.24997C6.58322 6.16664 7.49989 5.24997 8.58322 5.24997C9.41656 5.24997 10.1666 5.74997 10.4999 6.49997C10.8332 6.0833 11.3332 5.66664 11.7499 5.3333C10.6666 3.5833 8.41656 2.99997 6.66656 4.0833C4.91656 5.16664 4.33322 7.41664 5.41656 9.16664C6.08322 10.25 7.24989 10.9166 8.58322 10.9166Z"
        fill="#FA9D31"
      />
      <path
        d="M21.7499 18.9167L21.5833 18.6667C19.9166 16.8333 17.5833 15.75 15.0833 15.8333C12.5833 15.75 10.1666 16.8333 8.49992 18.6667L8.33325 18.9167V25.25C8.33325 26 8.91659 26.6667 9.74992 26.6667H20.4166C21.1666 26.6667 21.8333 26 21.8333 25.25V18.9167H21.7499ZM20.0833 25H9.99992V19.5C11.3333 18.1667 13.1666 17.5 15.0833 17.5C16.9166 17.4167 18.7499 18.1667 20.0833 19.5V25Z"
        fill="#FA9D31"
      />
    </g>
    <defs>
      <clipPath id="clip0_9604_4159">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SliderIcon = ({ selected }: { selected: Boolean }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 11H17.816C17.6124 10.4154 17.2318 9.90874 16.7273 9.5502C16.2227 9.19165 15.619 8.99902 15 8.99902C14.381 8.99902 13.7773 9.19165 13.2727 9.5502C12.7682 9.90874 12.3876 10.4154 12.184 11H3C2.73478 11 2.48043 11.1053 2.29289 11.2929C2.10536 11.4804 2 11.7348 2 12C2 12.2652 2.10536 12.5195 2.29289 12.7071C2.48043 12.8946 2.73478 13 3 13H12.184C12.3876 13.5845 12.7682 14.0912 13.2727 14.4497C13.7773 14.8083 14.381 15.0009 15 15.0009C15.619 15.0009 16.2227 14.8083 16.7273 14.4497C17.2318 14.0912 17.6124 13.5845 17.816 13H21C21.2652 13 21.5196 12.8946 21.7071 12.7071C21.8946 12.5195 22 12.2652 22 12C22 11.7348 21.8946 11.4804 21.7071 11.2929C21.5196 11.1053 21.2652 11 21 11ZM15 13C14.8022 13 14.6089 12.9413 14.4444 12.8314C14.28 12.7216 14.1518 12.5654 14.0761 12.3827C14.0004 12.1999 13.9806 11.9989 14.0192 11.8049C14.0578 11.6109 14.153 11.4327 14.2929 11.2929C14.4327 11.153 14.6109 11.0578 14.8049 11.0192C14.9989 10.9806 15.2 11.0004 15.3827 11.0761C15.5654 11.1518 15.7216 11.2799 15.8315 11.4444C15.9414 11.6088 16 11.8022 16 12C16 12.2652 15.8946 12.5195 15.7071 12.7071C15.5196 12.8946 15.2652 13 15 13Z"
        fill={selected ? '#5579F2' : '#242424'}
      />
    </svg>
  );
};

export const DownloadIcon = ({
  size,
  color,
  hoverable,
}: {
  size: number | string;
  color: string;
  hoverable?: boolean;
}) => (
  <svg
    width={size ?? '24'}
    height={size ?? '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 12L12 17M12 17L17 12M12 17V4M6 20H18"
      stroke={color ?? '#242424'}
      stroke-linecap="round"
      stroke-linejoin="round"
      className={hoverable ? 'stroke-current' : ''}
    />
  </svg>
);

export const TickLogo = ({ color }: IconProps) => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M3.48334 5.50013L5.21191 6.94061L7.51668 4.05965M5.50001 9.53346C4.97034 9.53346 4.44587 9.42914 3.95652 9.22644C3.46717 9.02375 3.02254 8.72666 2.64801 8.35213C2.27348 7.9776 1.97639 7.53297 1.77369 7.04362C1.571 6.55427 1.46667 6.0298 1.46667 5.50013C1.46667 4.97047 1.571 4.44599 1.77369 3.95664C1.97639 3.46729 2.27348 3.02266 2.64801 2.64813C3.02254 2.2736 3.46717 1.97651 3.95652 1.77382C4.44587 1.57112 4.97034 1.4668 5.50001 1.4668C6.56972 1.4668 7.59561 1.89174 8.35201 2.64813C9.1084 3.40453 9.53334 4.43042 9.53334 5.50013C9.53334 6.56984 9.1084 7.59573 8.35201 8.35213C7.59561 9.10852 6.56972 9.53346 5.50001 9.53346Z"
      stroke={color}
    />
  </svg>
);
